import lazysizes from 'lazysizes'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import NoticeGlobal from 'snippets/notice-global/notice-global'
import register from 'preact-custom-element'
import 'libs/accessibility'
import 'styles/theme.css'
import 'snippets/accordion-list/accordion-list'
import 'snippets/carousel/carousel'
import 'modules/carousel-swiper/carousel-swiper-legacy'
import 'modules/carousel-swiper/carousel-swiper-custom'
import 'snippets/modal-dialog/modal-dialog'
import 'snippets/notice-main/notice-main'
import 'snippets/read-more/read-more'
import 'snippets/validate-form/validate-form'
import 'snippets/video-player/video-player'
import 'snippets/slideout/slideout'
import 'snippets/form/custom-input-password/custom-input-password'
import 'snippets/product/product-atc/product-quick-add'
import GiftWrappingModal from '../snippets/gift-wrapping-modal/gift-wrapping-modal'
import EngravingProductModal from 'snippets/engraving-product-modal/engraving-product-modal'
import PersonaliseProductModal from 'snippets/personalise-product-modal/personalise-product-modal'

register(NoticeGlobal, 'notice-global')
register(GiftWrappingModal, 'gift-wrapping-modal')
register(EngravingProductModal, 'engraving-product-modal')
register(PersonaliseProductModal, 'personalise-product-modal')

lazysizes.init()
